import type { ReactNode } from 'react';
import type React from 'react';
import type { DeepReadonly } from '@itandi/itandi-bb-ui';
import Styles from './Table.module.scss';

type Props = DeepReadonly<{
  children: ReactNode;
}>;

export const Table: React.FC<Props> = ({ children }: Props) => (
  <table className={Styles.Table}>{children}</table>
);
